import { BetslipUtilChannels, InternalMessageBusChannels } from "../../dependencies";
/**
 * @class
 * @implements {BsUtilMsgRouter}
 * @classdesc Internal message bus integration for BetslipUtilChannels and FullBetSlip channels for add/remove selections. Listen/Post messages through sbInternalMsgBus.
 */
export class InternalMsgRouter {
    constructor(msgBus) {
        this.msgBus = msgBus;
        this.listeners = {};
        this.betslipListeners = {};
        Object.keys(BetslipUtilChannels.Listen.Commands).forEach(key => {
            this.listeners[BetslipUtilChannels.Listen.Commands[key]] = key;
        });
        this.betslipListeners[InternalMessageBusChannels.legacy.betslip.items.add] = "selectionAdded";
        this.betslipListeners[InternalMessageBusChannels.legacy.betslip.items.remove] = "selectionRemoved";
    }
    attachBetslipListeners(onMessageReceived, context) {
        Object.keys(this.betslipListeners).forEach(x => this.msgBus.on(x, onMessageReceived.bind(context)));
    }
    detachBetslipListeners(onMessageReceived, context) {
        Object.keys(this.betslipListeners).forEach(x => this.msgBus.off(x, onMessageReceived.bind(context)));
    }
    attachListeners(onMessageReceived, context) {
        Object.keys(this.listeners).forEach(x => this.msgBus.on(x, onMessageReceived.bind(context)));
    }
    detachListeners(onMessageReceived, context) {
        Object.keys(this.listeners).forEach(x => this.msgBus.off(x, onMessageReceived.bind(context)));
    }
    sendMessage(channel, data) {
        this.msgBus.emit(channel, data);
    }
}
//# sourceMappingURL=InternalMsgRouter.js.map